import {api} from '../../utils/api'
import store from '../store'


export default {


    /**
     * load node templates list
     * @param commit
     * @param tags
     * @param parentId
     * @returns {*|Promise|Promise<any>}
     */
    loadStructure({commit}, tags) {
        // Load tasks
        return api.call(commit, 'get', `/api/tree/structure/${tags.join(',')}`, false, 'INIT_TASKS');
    },

    /**
     * load node templates list
     * @param commit
     * @param tags
     * @param parent_id
     * @param parentId
     * @returns {*|Promise|Promise<any>}
     */
    loadParentStructure({commit}, {tags, parent_id}) {
        // Load tasks
        return api.call(commit, 'get', `/api/tree/structure/${tags.join(',')}/${parent_id}`, false, 'SET_TASKS');
    },

    /**
     * load structure
     * @param commit
     * @param tags
     * @returns {*|Promise|Promise<any>}
     */
    loadTemplates({commit}, id) {
        // Load tasks
        return api.call(commit, 'get', `/api/tree/load-templates/${id}`, false, 'SET_TASKS');
    },

    /**
     * load structure
     * @param commit
     * @param ids
     * @returns {*|Promise|Promise<any>}
     */
    loadNodeStructure({commit}, ids) {

        // Load list
        let loadList = [];

        // Ids list to load strucure if not loaded
        for(const id of ids) {
            if(!window.app.$get('tree/getTaskByID', id)) {
                window.app.$dispatch('tree/setTasks', {id: id});
                loadList.push(id);
            }
        }

        // If no ids to load return promise and resolve it
        if(!loadList.length)
            return Promise.reject();

        // Load tasks
        return api.call(commit, 'post', `/api/tree/nodes-structure`, {ids: loadList}, 'SET_TASKS');
    },

    /**
     * load structure
     * @param commit
     * @param ids
     * @returns {*|Promise|Promise<any>}
     */
    setTasks({commit}, ids) {
        // Check for array
        if(!Array.isArray(ids)) ids = [ids];

        // Set tasks
        commit("SET_TASKS", ids)
    },

    /**
     * load Node
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadNode({commit}, ids) {

        // Check for array
        if(!Array.isArray(ids)) ids = [ids];

        // Load tasks
        // Filtering is possible only for root node
        // Otherwise fitlering will be skipped
        return api.call(commit, 'get', '/api/tree/level/' + ids.join(",") + '/' + store.getters["tree/getTaskListTags"], false, 'SET_TASKS');
    },

    /**
     * load users tasks
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadUsersTasks({commit}) {

        // Load tasks
        return api.call(commit, 'get', '/api/tree/user-tasks/'+ store.getters["tree/getTaskListTags"], false, 'SET_TASKS');
    },

    /**
     * reload Node
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    reloadTree({commit}) {

        // Apply to state first
        commit("RESET_TASKS", []);

        // Reload parent
        window.app.$dispatch("tree/loadNode", 0);

    },

    /**
     * load task
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadTask({commit}, id) {

        // Load tasks
        // Filtering is possible only for root node
        // Otherwise fitlering will be skipped
        return api.call(commit, 'get', '/api/tree/load/' + id, false, 'SET_TASKS');
    },

    /**
     * load task
     * @param commit
     * @param ids
     * @returns {*|Promise|Promise<any>}
     */
    loadTasksList({commit}, ids) {

        // Load tasks
        return ids.length ? api.call(commit, 'post', '/api/tree/load-list', {ids: ids}, 'SET_TASKS') : false;
    },


    /**
     * load task notification object
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadTaskNotification({commit}, id) {

        // Load task notification object
        return api.call(commit, 'get', '/api/task-notification/' + api.clearInstance(id), false, 'SET_TASK_NOTIFICATIONS');
    },


    /**
     * Store task notification object
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    saveTaskNotification({commit}, payload) {

        // Load task notification object
        return api.call(commit, 'patch', '/api/task-notification/' + api.clearInstance(payload.id), api.cleanTaskInstances(["id"], payload));
    },


    /**
     * Set title
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setTitle({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-title", payload, "SET_TASKS");
    },


    /**
     * Set progress
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setProgress({commit}, payload) {

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-progress", payload, "SET_TASKS");
    },



    /**
     * Set daily task
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setDaily({commit}, payload) {

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-daily", payload, "SET_TASKS");
    },


    /**
     * Paste task
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    pasteTask({commit}, {source_id, parent_id}) {

        // Store title
        return api.call(commit, 'post', '/api/tree/' + source_id + "/paste/" + parent_id, false, "SET_TASKS");
    },


    /**
     * Instantiate template
     * @param commit
     * @param template_id
     * @param parent_id
     * @returns {*|Promise|Promise<any>}
     */
    instantiateTemplate({commit}, {template_id, parent_id, values}) {

        // Store title
        return api.call(commit, 'post', '/api/tree/' + template_id + "/instantiate/" + parent_id, values, "SET_TASKS");
    },


    /**
     * Set deferred
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setDeferred({commit}, payload) {

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-deferred/" + payload.deferred, false, "SET_TASKS");
    },

    /**
     * Set min start time
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setMinStartTime({commit}, payload) {

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-min-start-time/" + payload.min_start_time, false, "SET_TASKS");
    },

    /**
     * Set deadline
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setDeadline({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-deadline", payload);
    },

    /**
     * Set auto deadline
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    setAutoDeadline({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-auto-deadline", payload, "SET_TASKS");
    },

    /**
     * Set delay time
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setDelayTime({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-delay-time/" + payload.delay_time, payload);
    },

    /**
     * Set suspended
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setSuspended({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-suspended", payload);
    },

    /**
     * Set suspended
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setEstimatedTime({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-estimated", payload);
    },

    /**
     * Set suspended
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setAcceptanceFraction({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-acceptance-fraction", payload);
    },

    /**
     * Set exec time
     * @param commit
     * @param id
     * @param execution_time
     * @returns {*|Promise|Promise<any>}
     */
    setExecDays({commit}, {id, execution_days}) {

        // Apply to state first
        commit("SET_TASKS", {id, execution_days});

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + id + "/set-exec-days", {execution_days});
    },

    /**
     * Set type
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setType({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-type", payload);
    },

    /**
     * Set sub type
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setSubType({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-subtype", payload);
    },

    /**
     * Set priority
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setPriority({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-priority", payload);
    },

    /**
     * Set handler
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setHandler({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-handler", payload);
    },

    /**
     * Set alias
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setAlias({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-alias", payload);
    },

    /**
     * Set roadmap goal
     * @param commit
     * @param id
     * @param goal_id
     * @returns {*|Promise|Promise<any>}
     */
    setRoadmapGoal({commit}, {id, roadmap_goal_id}) {

        // Store title
        return api.call(commit, 'patch', `/api/tree/${id}/set-goal/${roadmap_goal_id}`, false, "SET_TASKS");
    },

    /**
     * Set multiple values mode
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    setMultipleValues({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-multiple-values", payload);
    },

    /**
     * Set linked task
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setLinkedTask({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-linked-task", payload);
    },


    /**
     * Save task
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    saveTask({commit}, payload) {

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/save-task", payload, 'SET_TASKS');
    },


    /**
     * Set description
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setDescription({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-description", payload, "SET_TASKS");
    },


    /**
     * Set position
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setPosition({commit}, payload) {

        // Store title
        let pr = api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-position", payload).then( (dt) => {

            // check for result
            if(dt['id']) {

                // Apply to state first
                commit("SET_TASKS", payload);

                // Invalidate parent node
                commit("INVALIDATE_TASK", payload.parent_id);
            }
        });

        // Return promise
        return pr;
    },

    /**
     * Invalidate task
     * @param commit
     * @param id
     */
    invalidateTask({commit}, id) {
        // Invalidate parent node
        commit("INVALIDATE_TASK", id);
    },


    /**
     * Set supervisors
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setSupervisors({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-supervisors", payload);
    },


    /**
     * Set followers
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setFollowers({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-followers", payload);
    },

    /**
     * Set assignees
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setAssignees({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-assignees", payload);
    },

    /**
     * Set assignee posiitons
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setAssigneePositions({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-assignee-positions", payload);
    },

    /**
     * Set acceptors
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setAcceptors({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-acceptors", payload);
    },

    /**
     * Set acceptor positions
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setAcceptorPositions({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-acceptor-positions", payload);
    },


    /**
     * Set parent
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setParent({commit}, payload) {

        // Apply to state first
        commit("SET_TASKS", payload);

        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.id + "/set-parent", payload);
    },


    /**
     * create new task
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    createTask({commit}, payload) {
        // Store title
        return api.call(commit, 'patch', '/api/tree/' + payload.parent_id + "/save-task", payload, 'SET_TASKS');
    },


    /**
     * Update task
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    updateTask({commit}, payload) {

        // Don't process deleted or readonly tasks
        if (!payload.title || payload.read_only || payload.deleted /*|| !payload.permissions['write']*/) return api.emptyPromise();

        // Apply to state first
        commit("SET_TASKS", payload);

        // Update task
        return api.call(commit, 'patch', '/api/tree/' + payload.id, api.cleanTaskInstances(["id", "parent_id"], payload), payload.instance_id ? false : "RESET_TASKS");
    },

    /**
     * Set dependent task
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    setDependentTask({commit}, payload) {

        // Don't process deleted or readonly tasks
        if (payload.read_only || payload.deleted /*|| !payload.permissions['write']*/) return api.emptyPromise();

        // Update task
        return api.call(commit, 'get', '/api/tree/' + payload.target + "/dependency/" + payload.parent + "/" + (payload.mode ? "set" : "clear"), null, 'SET_DEPENDENCY');
    },

    /**
     * Expand node
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    expandNode({commit}, payload) {
        // Apply to state first
        commit("EXPAND_TASK", payload);
    },

    /**
     * Set wait children mode
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    showAwaitChildren({commit}, payload) {
        commit("SHOW_AWAIT_CHILDREN", payload);
    },

    /**
     * Set closed children mode
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    showClosedChildren({commit}, payload) {
        // Apply to state first
        commit("SHOW_CLOSED_CHILDREN", payload);
    },

    /**
     * Set deferred children mode
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    showDeferredChildren({commit}, payload) {
        // Apply to state first
        commit("SHOW_DEFERRED_CHILDREN", payload);
    },

    /**
     * Expand node path
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    expandPath({commit}, id) {
        // Apply to state first
        commit("EXPAND_PATH", id);
    },

    /**
     * Set active task
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    setActiveTask({commit}, id) {
        // Apply to state first
        commit("ACTIVE_TASK", id);
    },

    /**
     * Store task to be copied
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    setCopyTaskID({commit}, id) {
        // Apply to state first
        commit("COPY_TASK", id);
    },

    /**
     * Set active field
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setActiveField({commit}, payload) {

        // Apply to state first
        commit("ACTIVE_TASK_FIELD", payload);
    },

    /**
     * Set task list query string
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    setTaskListQuery({commit}, query) {
        // Apply to state first
        commit("SET_TASK_LIST_QUERY", query);
    },

    /**
     * Set task list tags
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    setTaskListTags({commit}, tags) {
        // Apply to state first
        commit("SET_TASK_LIST_TAGS", tags);
    },

    /**
     * Set task list tags
     * @param commit
     * @param notType
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    setTreeNotificationFilter({commit}, notType) {
        // Apply to state first
        commit("SET_TREE_NOTIFICATION_FILTER", notType);
    },

    /**
     * Activate tasks list block
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    setTaskListMode({commit}, mode) {
        // Apply to state first
        commit("TASK_LIST_MODE", mode);
    },

    /**
     * Delete task
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    deleteTask({commit}, payload) {

        // Don't process deleted or readonly tasks
        if (payload.read_only || payload.deleted /*|| !payload.permissions['write']*/) return api.emptyPromise();

        // Apply to state first
        commit("DELETE_TASKS", payload);

        // Update task
        return api.call(commit, 'delete', '/api/tree/' + payload.id);
    },

    /**
     * Delete task locally
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    deleteTaskLocal({commit}, payload) {

        // Apply to state first
        commit("DELETE_TASKS", payload);

        // Don't delete fake tasks
        return api.emptyPromise();
    },


    /**
     * Close task by user
     * @param commit
     * @param payloadtfe
     * @returns {*|Promise|Promise<any>}
     */
    closeTask({commit}, payload) {

        // Set task info
        // commit('SET_TASKS', payload);

        // Update task
        return api.call(commit, 'get', '/api/tree/' + payload.id + '/close', payload, 'SET_TASKS');
    },

    /**
     * Notifications readed
     * @param commit
     * @param payloadtfe
     * @returns {*|Promise|Promise<any>}
     */
    notificationsRead({commit}, payload) {

        // Update task
        return api.call(commit, 'get', '/api/tree/' + payload.id + '/notifications-read', payload, 'SET_TASKS');
    },

    /**
     * Notifications unreaded
     * @param commit
     * @param payloadtfe
     * @returns {*|Promise|Promise<any>}
     */
    notificationsUnread({commit}, payload) {

        // Update task
        return api.call(commit, 'get', '/api/tree/' + payload.id + '/notifications-unread', payload, 'SET_TASKS');
    },

    /**
     * Reopen task by user
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    reopenTask({commit}, payload) {

        // Update task
        return api.call(commit, 'get', '/api/tree/' + payload.id + '/reopen', payload, 'SET_TASKS');
    },

    /**
     * Accept task by user
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    acceptTask({commit}, payload) {

        // Update task
        return api.call(commit, 'get', '/api/tree/' + payload.id + '/accept', payload, 'SET_TASKS');
    },

    /**
     * Update task last activity
     * @param commit
     * @param id
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    updateLastActivity({commit}, id) {

        // Update task
        return api.call(commit, 'get', '/api/tree/' + id + '/update-last-activity', id, 'SET_TASKS');
    },

    /**
     * Update value
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    updateValue({commit}, payload) {
        return api.call(commit, 'patch', '/api/fields/value/' + payload.task_field_value_id + "/" + payload.task_field_instance_id, payload, 'SET_TASKS');
    },

    /**
     * Delete value
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    deleteInstance({commit}, id) {
        return api.call(commit, 'get', '/api/fields/value/' + id + "/delete", false, 'SET_TASKS');
    },


    /**
     * Create field value instance
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    createFieldInstance({commit}, id) {
        return api.call(commit, 'get', '/api/fields/value/' + id + "/create", false, 'SET_TASKS');
    },

    /**
     * Update value
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    createValue({commit}, payload) {
        return api.call(commit, 'post', '/api/fields/value/' + payload.task_field_instance_id + "/" + payload.id, payload, 'SET_TASKS');
    },


    /**
     * load messaged
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadCurrent({commit}) {
        return api.call(commit, 'get', '/api/timelog/current', null, 'SET_CURRENT');
    },

    /**
     * Start logging
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    start({commit}, id) {
        return api.call(commit, 'get', '/api/timelog/start/' + id, null, 'SET_CURRENT');
    },

    /**
     * Stop logging
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    stop({commit}) {
        return api.call(commit, 'get', '/api/timelog/stop', null, 'SET_CURRENT');
    },

    /**
     * Increase current time
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    incCurTime1sec({commit}) {
        commit("INC_CURRENT_TIME_1SEC");
    },


    /**
     * Set loaded flag
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setLoaded({commit}, id) {
        commit("SET_LOADED", id);
    },

    /**
     * Set tasks list to be filtered by
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    setFilterByTasks({commit}, ids) {
        commit("SET_FILTERED_BY_TASKS", ids);
    },


}
